import React, {HTMLAttributes} from 'react';
import classnames from 'classnames';
import {useDesignContext} from '@theme';
import './baseLabel.less';

type AppLabelProps = HTMLAttributes<HTMLLabelElement> & {
    children: React.ReactNode;
    className?: string;
    disabled?: boolean;
};

export const AppLabel = ({
    children, className, disabled, ...rest
}: AppLabelProps) => {
    const {designVersion} = useDesignContext();
    const containerClassName = classnames('app-label', className, designVersion, {disabled});
    return (
        <label
            className={containerClassName}
            {...rest}
        >
            {children}
        </label>
    );
};
export default AppLabel;
